import { styled } from "@mui/material/styles";
import { TextField, Typography as T, TypographyProps } from "@mui/material";
import { colors } from "../styles";

export const FieldHeader = (props: TypographyProps) => {
  return (
    <T {...props} variant="mdReg">
      {props.children}
    </T>
  );
};

export const TextInput = styled(TextField)({
  margin: "8px 0",
  width: "100%",
  "& label.Mui-focused": {
    color: "#667085",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#667085",
      border: `1px solid #667085`,
      opacity: 0.5,
    },
    "&.Mui-focused fieldset": {
      borderColor: "#667085",
      border: `1px solid #667085`,
    },
  },
  "& ::placeholder": {
    fontSize: "14px",
  },
});

export const PageHeader = styled("h2")(`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 17px;
  color: ${colors.black};
  margin: 20px 0px;
`);

export const PageSubHeader = styled("p")(`
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 17px;
  color: #475467;
  margin: 0px;
`);

export const Section = styled("div")(`
`);

export const SectionFlexRow = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  width: "100%",
});
export const SectionFlexColumn = styled("div")({
  display: "flex",
  flexDirection: "column",
});
